"use strict";

exports.__esModule = true;
exports.ERRORS = exports.ERROR_NAMES = void 0;
var ERRORS = {
  INVALID_TAG_STRUCTURE: createError('INVALID_TAG_STRUCTURE'),
  INVALID_JSON: createError('INVALID_JSON'),
  TAG_ALREADY_EXISTS: createError('TAG_ALREADY_EXISTS', 'duplicates'),
  TAG_CONTAINS_BLACKLISTED_ATTRIBUTE: createError('TAG_CONTAINS_BLACKLISTED_ATTRIBUTE', 'duplicates'),
  TAG_TYPE_NOT_ALLOWED: createError('TAG_TYPE_NOT_ALLOWED'),
  EMPTY_STRING: createError('EMPTY_STRING'),
  INVALID_URL_CHARACTERS: createError('INVALID_URL_CHARACTERS'),
  INVALID_FULL_URL: createError('INVALID_FULL_URL'),
  CUSTOM_VALIDATOR: createError('CUSTOM_VALIDATOR', 'validatorIndex')
};
exports.ERRORS = ERRORS;
var ERROR_NAMES = Object.keys(ERRORS).reduce(function (acc, curr) {
  acc[curr] = curr;
  return acc;
}, {});
exports.ERROR_NAMES = ERROR_NAMES;

function createError(name, parameterName) {
  return function SeoError(parameter) {
    var error = new Error(name);
    error.name = name;

    if (parameterName && typeof parameter !== 'undefined') {
      error[parameterName] = parameter;
    }

    return error;
  };
}